"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useShellContext_1 = require("hooks/useShellContext");
const auth_1 = require("modules/auth");
const membership_1 = require("modules/membership");
const user_1 = require("modules/user");
const useDatahubBaseEvent = () => {
    var _a;
    const { isMembership, slug } = (0, useShellContext_1.useShellContext)();
    return {
        client: isMembership ? 'MEMBERSHIP' : 'STANDALONE',
        productId: membership_1.MembershipStore.productId || 0,
        productType: membership_1.MembershipStore.isOnlineEventTemplate
            ? 'ONLINE_EVENT'
            : 'ONLINE_COURSE',
        slug,
        userId: Number(user_1.UserStore.marketplaceId) || 0,
        userRole: (_a = auth_1.AuthService.roles) === null || _a === void 0 ? void 0 : _a[0]
    };
};
exports.default = useDatahubBaseEvent;
